// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__VkKpE","file":"styles_file__17z1_"};